module.exports = __webpack_public_path__ + "media/images/pages/solutions/services/client_sample-09ab94c699650a07cbe316d5cb6d87e9.svg";